import React from 'react';

import './PlanComparisonList.css';


const PlanComparisonList = () => {
  return (
    <div className="PlanComparisonList">
      <div className="card-group align-items-stretch">

        <div className="card text-right pr-2">

          <div className="card-cell">
            <div className="card-title"> &nbsp; </div>
          </div>

          <div className="card-cell"> Lessons minutes per day            </div>
          <div className="card-cell"> Languages                          </div>
          <div className="card-cell"> 24/7 Availability                  </div>
          <div className="card-cell"> Fully-vetted professional teachers </div>
          <div className="card-cell"> Personalized Lesson Plans          </div>
          <div className="card-cell" />
        </div>

        <div className="card text-center">

          <div className="card-cell">
            <div className="card-title d-flex flex-column">
              <h3 className="mt-sm-1"> GO </h3>

              <p className="mt-auto mb-0">
                <small> from </small>
                <strong className="price"> $95/mo </strong>
              </p>

            </div>
          </div>

          <div className="card-cell"> Up to 1 </div>
          <div className="card-cell"> 1 </div>
          <div className="card-cell"> <i className="fa fa-check text-success" /> </div>
          <div className="card-cell"> <i className="fa fa-check text-success" /> </div>
          <div className="card-cell"> <i className="fa fa-check text-success" /> </div>

          <div className="card-cell align-items-center">
            <button
              className="btn btn-outline-primary btn-block"
              type="button"
            >
              Start <wbr /> Today
            </button>
          </div>

        </div>

        <div className="card text-center highlight">

          <div className="card-cell">
            <div className="card-title d-flex flex-column">
              <h3 className="mt-sm-1"> X </h3>

              <p className="mt-auto mb-0">
                <small> from </small>
                <strong className="price"> $195/mo </strong>
              </p>
            </div>
          </div>

          <div className="card-cell"> Up to 2 </div>
          <div className="card-cell"> 1 </div>
          <div className="card-cell"> <i className="fa fa-check" /> </div>
          <div className="card-cell"> <i className="fa fa-check" /> </div>
          <div className="card-cell"> <i className="fa fa-check" /> </div>

          <div className="card-cell align-items-center">
            <button
              className="btn btn-primary btn-block"
              type="button"
            >
              Start <wbr /> Today
            </button>
          </div>

        </div>

        <div className="hidden-xs-up card text-center">

          <div className="card-cell">
            <div className="card-title d-flex flex-column">
              <h3 className="mt-sm-1"> X+ </h3>

              <p className="mt-auto mb-0">
                <small> from </small>
                <strong className="price"> $255/mo </strong>
              </p>
            </div>
          </div>

          <div className="card-cell"> Up to 2 </div>
          <div className="card-cell"> Unlimited </div>
          <div className="card-cell"> <i className="fa fa-check text-success" /> </div>
          <div className="card-cell"> <i className="fa fa-check text-success" /> </div>
          <div className="card-cell"> <i className="fa fa-check text-success" /> </div>

          <div className="card-cell align-items-center">
            <button
              className="btn btn-outline-primary btn-block"
              type="button"
            >
              Start <wbr /> Today
            </button>
          </div>

        </div>

      </div>
    </div>
  );
};

export default PlanComparisonList;



// WEBPACK FOOTER //
// ./src/components/PlanComparisonList/PlanComparisonList.js